// SPDX-License-Identifier: MIT
// The single « ✦ Construis-le » next-step beacon (guided first-run §5.9). After
// magnify it is the ONE surfaced continuation of the spine — calm until the
// readiness gauge is full, then prominent (glow + « t'as tout ce qu'il faut »).
// Wires to the real build/deliver path. Self-scoping (.gfr) so it renders styled
// in the production card (no .gfr ancestor) — the harness-vs-prod fidelity trap.
import { t } from '../i18n/t';
import { escapeHtml } from '../lib/escape';

export interface BuildBeaconOptions {
  ready: boolean;            // readiness.ready → calm (false) vs prominent glow (true)
  onBuild(): void;
  sub?: string;              // optional subline override (e.g. a beat-specific flourish)
}

export function renderBuildBeacon(opts: BuildBeaconOptions): HTMLButtonElement {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'beacon gfr';
  b.setAttribute('data-component', 'build-beacon');
  b.setAttribute('data-ready', String(opts.ready));
  const sub = opts.sub ?? t(opts.ready ? 'onboarding.buildReady' : 'onboarding.buildCalm');
  b.innerHTML = `<span class="beacon__main">${escapeHtml(t('onboarding.buildBeacon'))}</span><small>${escapeHtml(sub)}</small>`;
  b.addEventListener('click', () => opts.onBuild());
  return b;
}
